export type { MedicalInfoPageProps } from "./medical-info-page";
export { MedicalInfoPage } from "./medical-info-page";
